module.exports = __webpack_public_path__ + "static/media/crown_black.8e05a95a.PNG";